export const environment = {
  production: false,
  token_sistema: 'd7f988768274419b90ef13f6556d8fcfe4ec9bfbc4f04978a9b1ba2328b4aa11',
  url_api_ms: 'https://as-cl-agpsa-modulo-seguridad-net-core-dev.azurewebsites.net/',
  url_api_log: 'https://api-internas.agpsa.cl/api-log/'
};
